module.exports = __webpack_public_path__ + "static/media/banner.49470aa2.jpg";